import React from "react";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { ApplicationState } from "../../store";
import { breachSafetyScoreBetween } from "../../util/CommonBreach";
import { breachScore } from "../Breaches/BreachConstants";
import BreachIQNoScore from "../Breaches/BreachIQNoScore";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const BreachIQCard = () => {
    const breachSummaryData = useSelector((state: ApplicationState) =>
        state.breachSummaryState ? (state.breachSummaryState.breachSummaryData ? state.breachSummaryState.breachSummaryData : null) : null
    );

    const isLoading = useSelector((state: ApplicationState) => state.breachSummaryState && state.breachSummaryState.isLoading);

    const history = useHistory();

    const openActionCount = breachSummaryData && breachSummaryData.actionToDoSummary ? breachSummaryData.actionToDoSummary.openActionCount : 0;

    const newDetectedBreachCount =
        breachSummaryData && breachSummaryData.detectedBreachSummary ? breachSummaryData.detectedBreachSummary.newDetectedBreachCount : 0;

    const detectedBreachAvailable = breachSummaryData && breachSummaryData.isDetectedBreachAvailable ? breachSummaryData.isDetectedBreachAvailable : false;
    const totalBreach = breachSummaryData && breachSummaryData.totalNumberOfBreaches ? breachSummaryData.totalNumberOfBreaches : 0;

    const { t: tLang } = useTranslation();

    const handleKeyDown = (e: { keyCode: number }) => {
        if (e.keyCode === 13) {
            history.push("/breaches");
        }
    };
    const handleBreachClick = (e: { keyCode: number }) => {
        if (e.keyCode === 13) {
            history.push("/breaches");
        }
    };
    const handleSearchBreach = (e: { keyCode: number }) => {
        if (e.keyCode === 13) {
            history.push("/breaches/search-breaches");
        }
    };

    const isScoreHundred = breachSummaryData && breachSummaryData.customerBreachScore === 100;
    return (
        <React.Fragment>
            {breachSummaryData && breachSummaryData.customerBreachScore && !(totalBreach === 0 && isScoreHundred) ? (
                <div className={isLoading ? "box loading" : "box"}>
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-text has-actions">
                                <h2 className="brach-text-color">BreachIQ™</h2>
                            </div>
                        </div>
                        <div className="box-actions">
                            <Link to="/breaches/exposures" className="default_link">
                                View Breaches
                            </Link>
                        </div>
                    </div>
                    <div className="box-content">
                        <div className="row">
                            <div className="col-xs-12 col-sm-6 breach-mg-btm">
                                <div className="breach-widget-border" style={{ minHeight: "8.79rem" }}>
                                    <div className="col-xs-12 text-align-center" style={{ paddingTop: "0.75rem" }}>
                                        <h5 className="brach-text-color">{tLang("dashboard.breachIq.yourIdSafetyScore")}</h5>
                                    </div>
                                    <div className="breach-risk-card">
                                        <div
                                            className={`risk-card ${breachScore[breachSafetyScoreBetween(breachSummaryData.customerBreachScore)]["border"]}`}
                                            role="link"
                                            tabIndex={0}
                                            onKeyDown={handleKeyDown}
                                            onClick={() => {
                                                history.push("/breaches");
                                            }}
                                        >
                                            <div
                                                className={`padding-right-s risk-count brach-text-color ${
                                                    breachScore[breachSafetyScoreBetween(breachSummaryData.customerBreachScore)]["textColor"]
                                                }`}
                                            >
                                                {breachSummaryData.customerBreachScore}
                                            </div>
                                            <div
                                                className={`text-align-center ${
                                                    breachScore[breachSafetyScoreBetween(breachSummaryData.customerBreachScore)]["textColor"]
                                                }`}
                                            >
                                                <div className="risk-description-1">
                                                    {breachScore[breachSafetyScoreBetween(breachSummaryData.customerBreachScore)]["text"]}
                                                </div>
                                                <div className="risk-description-2">{`(${breachSummaryData.customerBreachScore} out of 100)`}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={detectedBreachAvailable ? "col-xs-12 col-sm-6 brach-text-color" : "col-xs-12 col-sm-6 brach-text-color breach-mg-btm"}>
                                <div className="breach-widget-border" style={{ minHeight: "8.79rem" }}>
                                    <div className="col-xs-12 text-align-center">
                                        {openActionCount ? (
                                            <h5 className="breach-open-actions">
                                                You have <span>{openActionCount}</span> open actions{" "}
                                            </h5>
                                        ) : (
                                            <div>
                                                <div className="display-flex-justify-center-align-center text-align-center">
                                                    <div className="no-breach-score-complete-label">
                                                        <span className="onboarding-task-icon">
                                                            <em className="las la-check-circle breach-action-complete-icon" style={{ fontSize: "1.5rem" }}></em>
                                                        </span>
                                                        <div
                                                            style={{
                                                                paddingLeft: "0.5rem",
                                                                textAlign: "start",
                                                                lineHeight: 1.57,
                                                            }}
                                                        >
                                                            {tLang("dashboard.breachIq.allActionsComplete")}
                                                        </div>
                                                    </div>
                                                </div>
                                                <span style={{ fontSize: "0.75rem", lineHeight: 1.42 }}>{tLang("dashboard.breachIq.greatJob")}</span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="text-align-center" style={{ padding: "0.75rem 0.3rem" }}>
                                        <Link
                                            to="/breaches/action-plan"
                                            type="button"
                                            onClick={() =>
                                                window.addToDataLayer({
                                                    event: openActionCount
                                                        ? tLang("dashboard.breachIq.completeActionButtonText")
                                                        : tLang("dashboard.breachIq.completedAction"),
                                                })
                                            }
                                            className="btn-default btn-secondary-outline"
                                        >
                                            <span className="btn-text">
                                                {openActionCount
                                                    ? tLang("dashboard.breachIq.completeActionButtonText")
                                                    : tLang("dashboard.breachIq.completedAction")}
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {newDetectedBreachCount ? (
                            <div className="row">
                                <div
                                    className="col-xs-12 widget-new-breach breach-widget-border"
                                    style={{ margin: "0px 0.5rem", cursor: "pointer" }}
                                    role="link"
                                    tabIndex={0}
                                    onKeyDown={handleBreachClick}
                                    onClick={() => {
                                        history.push("/breaches");
                                    }}
                                >
                                    <div>
                                        <span className="dashboard-alert-icon breach-alert-icon padding-right-xs padding-left-xs">
                                            <em className="las la-exclamation-triangle icon-size-sm"></em>
                                        </span>
                                        <span className="padding-right-xs view-count-breach">{newDetectedBreachCount}</span>
                                        <span className="padding-right-xs breach-exposure-text">{tLang("dashboard.breachIq.newBreachDetected")}</span>
                                    </div>
                                    <div>
                                        <span>
                                            <em className="las la-angle-right"></em>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ) : detectedBreachAvailable ? (
                            <div style={{ padding: "0px 0.4rem" }}>
                                <div className="row widget-exposure-complete-main breach-widget-border">
                                    <div className="col-xs-12 col-sm-8">
                                        <div className="display-flex-item-center text-align-center">
                                            <div className="no-breach-score-complete-label" style={{ lineHeight: 1.07 }}>
                                                <span className="onboarding-task-icon">
                                                    <em className="las la-check-circle breach-action-complete-icon" style={{ fontSize: "1.5rem" }}></em>
                                                </span>
                                                <div
                                                    style={{
                                                        paddingLeft: "0.5rem",
                                                        paddingTop: "0.3rem",
                                                        textAlign: "start",
                                                    }}
                                                >
                                                    {tLang("dashboard.breachIq.reviewedAll")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-4 view-past-breach-main">
                                        <div
                                            onClick={() => {
                                                history.push("/breaches");
                                            }}
                                            onKeyDown={handleBreachClick}
                                            role="link"
                                            tabIndex={0}
                                            className="view-past-breach"
                                        >
                                            <span style={{ color: "#0a7087" }}>View past breaches</span>
                                            <span>
                                                <em className="las la-angle-right" style={{ color: "#00313c" }}></em>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div style={{ padding: "0px 0.4rem" }}>
                                <div className="row widget-breach-border">
                                    <div className="row widget-no-breach-title">
                                        <div className="col-xs-12 col-sm-8">
                                            <div className="box-header padding-left-5rem margin-left-xs-3">
                                                <div className="box-title-container" style={{ marginBottom: "unset" }}>
                                                    <div className="title-icon" aria-hidden="true" style={{ width: 41, height: 41 }}>
                                                        <RenderIcons iconName="breach-search" />
                                                    </div>
                                                    <div className="box-title-text" style={{ marginTop: "0.25rem" }}>
                                                        <h2 className="breach-section-title label">{tLang("dashboard.breachIq.heading")} </h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-4">
                                            <div
                                                className="search-link"
                                                role="link"
                                                tabIndex={0}
                                                onKeyDown={handleSearchBreach}
                                                onClick={() => {
                                                    history.push("/breaches/search-breaches");
                                                }}
                                            >
                                                <span>{tLang("dashboard.breachIq.searchLinkText")}</span>
                                                <span>
                                                    <em className="las la-angle-right" style={{ color: "#306e91" }}></em>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row widget-no-breach-description">
                                        <div className="col-xs-12" style={{ paddingTop: "unset", paddingBottom: "1.125rem" }}>
                                            <span>{tLang("dashboard.breachIq.description")} </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <></>
            )}
            {breachSummaryData && !isLoading && (!breachSummaryData.customerBreachScore || (totalBreach === 0 && isScoreHundred)) ? <BreachIQNoScore /> : <></>}
        </React.Fragment>
    );
};

export default BreachIQCard;
